"use client";

/**
 * Layout das rotas protegidas do TIDE VÍDEO (Fase 2.3 / ADR-VID-005).
 *
 * Adaptado de frontend/src/app/video/layout.tsx: sem AuthProvider de usuário
 * (JWT) — auth NK é um token único compartilhado (ver lib/auth.tsx). Sem
 * avatar/nome de usuário (não existe conceito de usuário no standalone); o
 * botão "Sair" apenas limpa o token e volta pra /credencial.
 */

import Link from "next/link";
import { usePathname } from "next/navigation";

import { AuthProvider, ProtectedRoute, useAuth } from "@/lib/auth";

function VideoHeader() {
  const { logout } = useAuth();
  const pathname = usePathname();
  const isList = pathname === "/";

  return (
    <header className="flex h-12 shrink-0 items-center gap-4 border-b border-tide-border bg-tide-bg-secondary px-4">
      <Link href="/" className="flex items-center gap-2">
        <span className="text-lg font-bold text-tide-accent">TIDE</span>
        <span className="text-sm text-tide-text-muted">VÍDEO</span>
      </Link>

      <nav className="flex items-center gap-2 text-sm">
        <Link
          href="/"
          className={
            isList
              ? "font-medium text-tide-text-primary"
              : "text-tide-text-secondary hover:text-tide-text-primary"
          }
        >
          Levantamentos
        </Link>
        <span className="text-tide-text-muted">›</span>
        <Link
          href="/modelos"
          className={
            pathname === "/modelos"
              ? "font-medium text-tide-text-primary"
              : "text-tide-text-secondary hover:text-tide-text-primary"
          }
        >
          Flywheel
        </Link>
      </nav>

      <div className="flex-1" />

      <button
        onClick={logout}
        className="rounded-md px-2 py-1 text-xs text-tide-text-secondary hover:bg-tide-bg-hover hover:text-tide-text-primary"
        data-testid="btn-logout"
      >
        Sair
      </button>
    </header>
  );
}

export default function AppLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <AuthProvider>
      <ProtectedRoute>
        <div className="flex h-screen flex-col overflow-hidden bg-tide-bg-primary">
          <VideoHeader />
          <main className="flex flex-1 flex-col overflow-hidden">
            {children}
          </main>
        </div>
      </ProtectedRoute>
    </AuthProvider>
  );
}
